export default __webpack_public_path__ + "static/media/check.5c01842f.svg";